export const fileKeys = {
  all: () => ['files'],
  thumbnail: (driveId: string, itemId: string) => [
    ...fileKeys.all(),
    'thumbnail',
    driveId,
    itemId,
  ],
  details: (driveId: string, itemId: string) => [...fileKeys.all(), 'details', driveId, itemId],
  preview: (driveId: string, itemId: string) => [...fileKeys.all(), 'preview', driveId, itemId],
};
